import SmileSignin from "src/pages_/smile/signin";

export default SmileSignin;
